// extracted by mini-css-extract-plugin
module.exports = {"name":"external-talents-table_name__2bFuf","email":"external-talents-table_email__w53ny","textField":"external-talents-table_textField__1wrnA"};